module.exports = __webpack_public_path__ + "static/media/first-generation.53e76179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/first-generation.jpg
// module id = 725
// module chunks = 13